import { savePersistedFilters } from './persistListFilters';

export const ORDERS_LIST_FILTER_KEY = 'orders';
export const INVOICES_LIST_FILTER_KEY = 'invoices';

const toId = (value) => {
  if (value == null || value === '' || value === '-') {
    return null;
  }
  return value;
};

export const clientPath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/clients/${resolved}` : null;
};

export const clientTabPath = (id, tab) => {
  const base = clientPath(id);
  if (!base) {
    return null;
  }
  return tab ? `${base}?tab=${encodeURIComponent(tab)}` : base;
};

export const doctorPath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/doctors/${resolved}` : null;
};

export const orderPath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/orders/${resolved}` : null;
};

export const invoicePath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/invoices/${resolved}` : null;
};

export const userPath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/users/${resolved}` : null;
};

export const walletPath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/wallets/${resolved}` : null;
};

export const expensesPath = () => '/setting/expenses';

const emptyOrdersFilters = {
  client_id: null,
  doctor_id: null,
  formula_type_id: null,
  order_status: null,
  delivered: null,
  requested_at: [],
  delivered_at: [],
};

const emptyInvoicesFilters = {
  search: '',
  client_id: null,
  doctor_id: null,
  payment_status: null,
  created_at: [],
  draft_filter: 'non-drafts',
};

export function persistClientOrdersFilter(clientId) {
  savePersistedFilters(ORDERS_LIST_FILTER_KEY, {
    ...emptyOrdersFilters,
    client_id: Number(clientId),
  });
}

export function persistDoctorOrdersFilter(doctorId) {
  savePersistedFilters(ORDERS_LIST_FILTER_KEY, {
    ...emptyOrdersFilters,
    doctor_id: Number(doctorId),
  });
}

export function persistClientInvoicesFilter(clientId) {
  savePersistedFilters(INVOICES_LIST_FILTER_KEY, {
    ...emptyInvoicesFilters,
    client_id: Number(clientId),
  });
}

export function persistDoctorInvoicesFilter(doctorId) {
  savePersistedFilters(INVOICES_LIST_FILTER_KEY, {
    ...emptyInvoicesFilters,
    doctor_id: Number(doctorId),
  });
}

export function activitySubjectPath(entity, entityId) {
  const id = toId(entityId);
  if (id == null) {
    return null;
  }

  switch (String(entity || '')) {
    case 'Order':
      return orderPath(id);
    case 'Invoice':
      return invoicePath(id);
    case 'Client':
      return clientPath(id);
    case 'User':
      return userPath(id);
    case 'Wallet':
      return walletPath(id);
    default:
      return null;
  }
}

export function transactionReferencePath(record) {
  const type = record?.type;
  if (type === 'INVOICE') {
    return invoicePath(record?.invoice?.id ?? record?.invoice_id);
  }
  if (type === 'INVOICE_REFUND') {
    return invoicePath(record?.invoice?.id ?? record?.invoice_id) ?? walletPath(record?.wallet_id);
  }
  if (type === 'WALLET_RECHARGE' || type === 'WALLET_DEDUCTION') {
    return walletPath(record?.wallet_id);
  }
  if (type === 'EXPENSE') {
    return expensesPath();
  }
  return null;
}

export function canOpenTransactionReference(record, links) {
  const path = transactionReferencePath(record);
  if (!path) {
    return false;
  }
  if (path.startsWith('/invoices')) {
    return Boolean(links?.canOpenInvoice);
  }
  if (path.startsWith('/wallets')) {
    return Boolean(links?.canOpenWallet);
  }
  if (path.startsWith('/setting/expenses')) {
    return Boolean(links?.canOpenExpense);
  }
  return false;
}

export function canOpenActivitySubject(entity, links) {
  switch (String(entity || '')) {
    case 'Order':
      return Boolean(links?.canOpenOrder);
    case 'Invoice':
      return Boolean(links?.canOpenInvoice);
    case 'Client':
      return Boolean(links?.canOpenClient);
    case 'User':
      return Boolean(links?.canOpenUser);
    case 'Wallet':
      return Boolean(links?.canOpenWallet);
    default:
      return false;
  }
}
